module.exports = __webpack_public_path__ + "static/media/icon-easy_use.dce3ce8b.svg";